import { TYPES } from '@/entities/fields'
import i18n from '@/lang/i18n'

const DATAGRID_CONFIG = {
    hasInputFilter: false,
    filterable: true,
    sideBar: true,
    cleanFiltersButton: false,
    fitResponsive: true,
    editable: false,
}

const COLUMNS = [
    {
        headerName: i18n.t('users.name'),
        field: 'name',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('users.email'),
        field: 'email',
        type: TYPES.EMAIL,
    },
    {
        headerName: i18n.t('users.role'),
        field: 'role',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('users.createdAt'),
        field: 'createdAt',
        type: TYPES.DATE,
    },
]

export default {
    config: DATAGRID_CONFIG,
    columns: COLUMNS,
}
